import { render, staticRenderFns } from "./CopyableText.vue?vue&type=template&id=117de58b"
import script from "./CopyableText.vue?vue&type=script&lang=js"
export * from "./CopyableText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports